import React, { useState, useEffect } from "react";
import apiService from '../../../config';

const PrivateLandForm2 = () => {
    const [tableRows, setTableRows] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [editState, setEditState] = useState({});

    const [currentProjectId, setCurrentProjectId] = useState(null);
    const [currentProposalId, setCurrentProposalId] = useState(null);

    // Project Id
    useEffect(() => {
        const getProjectInfo = () => {
            const currentProjectData = localStorage.getItem('currentProjectData');
            if (currentProjectData) {
                try {
                    const projectData = JSON.parse(currentProjectData);
                    return { id: projectData.project_id || projectData.id };
                } catch (e) { console.error(e); }
            }
            const selectedProject = localStorage.getItem('selectedProject');
            if (selectedProject) {
                try {
                    const project = JSON.parse(selectedProject);
                    return { id: project.project_id || project.id };
                } catch (e) { console.error(e); }
            }
            const userData = localStorage.getItem('userData');
            if (userData) {
                try {
                    const user = JSON.parse(userData);
                    return { id: user.data?.project_id || user.project_id };
                } catch (e) { console.error(e); }
            }
            return { id: null };
        };
        setCurrentProjectId(getProjectInfo().id);
    }, []);

    // Proposal Id
    useEffect(() => {
        const getProposalInfo = () => {
            const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');
            try {
                return {
                    proposalId: currentProposal?.data?.default_proposal ||
                        currentProposal?.data?.proposal_id ||
                        currentProposal?.default_proposal ||
                        currentProposal?.proposal_id || null
                };
            } catch (e) { console.error(e); }
            return { proposalId: null };
        };
        setCurrentProposalId(getProposalInfo().proposalId);
    }, []);

    // Fetch data
    useEffect(() => {
        if (!currentProjectId || !currentProposalId) return;

        const fetchData = async () => {
            setLoading(true);
            setError(null);
            try {
                const response = await apiService.getRailwayLandHolding(currentProjectId, {
                    proposalId: currentProposalId
                });

                const landData = response?.data || [];

                const rows = landData.flatMap((parcel, parcelIndex) => {
                    const owners = parcel.owners || [];
                    return owners.map((owner, ownerIndex) => ({
                        sr: parcelIndex + ownerIndex + 1,
                        landId: parcel.LandAcquisition_id,
                        institution: "",
                        village: parcel.village_name || "-",
                        gatNo: parcel.survey_no || "-",
                        totalArea: parseFloat(owner.owner_total_area || 0).toFixed(2),
                        ownerName: owner.owner_name || "-",
                        acquiredArea: parseFloat(owner.owner_aqr_area || 0).toFixed(2),
                        remark: parcel.private_land_form2_remarks || ""
                    }));
                });

                setTableRows(rows);
            } catch (err) {
                console.error('Error fetching private land form2 data:', err);
                setError('माहिती लोड करताना त्रुटी आली.');
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [currentProjectId, currentProposalId]);

    const handleEdit = (index, row) => {
        setEditState(prev => ({ ...prev, [index]: { remark: row.remark } }));
    };

    const handleChange = (index, value) => {
        setEditState(prev => ({ ...prev, [index]: { remark: value } }));
    };

    const handleSave = async (index, landId) => {
        const edited = editState[index];
        if (!edited) return;
        try {
            await apiService.updateRailwayLandHolding(landId, {
                private_land_form2_remarks: edited.remark
            });
            setTableRows(prev => prev.map((r, i) =>
                i === index ? { ...r, remark: edited.remark } : r
            ));
            setEditState(prev => {
                const next = { ...prev };
                delete next[index];
                return next;
            });
        } catch (err) {
            console.error('Error updating remark:', err);
            alert('अपडेट करताना त्रुटी आली.');
        }
    };

    const handleCancel = (index) => {
        setEditState(prev => {
            const next = { ...prev };
            delete next[index];
            return next;
        });
    };

    return (
        <div className="p-4">
            <h2 className="text-center font-bold mb-2">पत्रक - २</h2>
            <p className="text-center mb-4 text-sm">
                अकोला–खंडवा रेल्वे मार्ग प्रकल्प – भूसंपादन विवरणपत्र
            </p>

            {loading && <p className="text-center text-blue-600 mb-4">लोड होत आहे...</p>}
            {error && <p className="text-center text-red-600 mb-4">{error}</p>}

            <table className="w-full border border-black border-collapse text-xs">
                <thead>
                    <tr>
                        <th className="border border-black p-1">भूसंपादन करणारी संस्था</th>
                        <th className="border border-black p-1">गावाचे नाव</th>
                        <th className="border border-black p-1">गट नंबर</th>
                        <th className="border border-black p-1">एकूण क्षेत्र (हे.आर.मी.)</th>
                        <th className="border border-black p-1">खातेदाराचे नाव</th>
                        <th className="border border-black p-1">भूसंपादनाचे क्षेत्र (हे.आर.मी.)</th>
                        <th className="border border-black p-1">शेरा</th>
                        <th className="border border-black p-1">क्रिया</th>
                    </tr>
                </thead>

                <tbody>
                    {tableRows.map((row, index) => {
                        const isEditing = !!editState[index];
                        return (
                            <tr key={index}>
                                <td className="border border-black p-1">{row.institution}</td>
                                <td className="border border-black p-1">{row.village}</td>
                                <td className="border border-black p-1">{row.gatNo}</td>
                                <td className="border border-black p-1">{row.totalArea}</td>
                                <td className="border border-black p-1">{row.ownerName}</td>
                                <td className="border border-black p-1">{row.acquiredArea}</td>
                                <td className="border border-black p-1">
                                    {isEditing ? (
                                        <input
                                            type="text"
                                            value={editState[index].remark}
                                            onChange={(e) => handleChange(index, e.target.value)}
                                            className="border border-gray-400 rounded px-1 py-0.5 w-full text-xs"
                                        />
                                    ) : (
                                        row.remark || "-"
                                    )}
                                </td>
                                <td className="border border-black p-1 text-center">
                                    {isEditing ? (
                                        <div className="flex gap-1 justify-center">
                                            <button
                                                onClick={() => handleSave(index, row.landId)}
                                                className="bg-green-600 text-white px-2 py-0.5 rounded text-xs hover:bg-green-700"
                                            >
                                                जतन
                                            </button>
                                            <button
                                                onClick={() => handleCancel(index)}
                                                className="bg-gray-400 text-white px-2 py-0.5 rounded text-xs hover:bg-gray-500"
                                            >
                                                रद्द
                                            </button>
                                        </div>
                                    ) : (
                                        <button
                                            onClick={() => handleEdit(index, row)}
                                            className="bg-blue-600 text-white px-2 py-0.5 rounded text-xs hover:bg-blue-700"
                                        >
                                            संपादित
                                        </button>
                                    )}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <p className="text-right mt-6 text-xs">
                उपकार्यकारी अभियंता, <br />
                (बांधकाम विभाग), <br />
                दक्षिण मध्य रेल्वे, अकोला
            </p>
        </div>
    );
};

export default PrivateLandForm2;